import './utils/tz';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { platformRouter } from './routes/platform';

const qc = new QueryClient({
  // refetchOnMount:'always' → 每次进/切回页面都后台拉最新（缓存先秒显示、随即刷新），
  // 解决「别处改了数据、staleTime(60s) 内切回看到旧数据」。staleTime 保留用于并发去重。
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, refetchOnMount: 'always', staleTime: 60_000 } },
});

// Suspense 兜底所有路由级 React.lazy 的挂起：初次进入/硬刷新 lazy 路由时显示加载态，
// 杜绝「lazy 组件无 Suspense 边界 → 同步挂起 → React #426」那类崩溃（站内跳转走 RR transition 不闪）。
const PageLoading = (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" />
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConfigProvider locale={zhCN}>
    <QueryClientProvider client={qc}>
      <Suspense fallback={PageLoading}>
        <RouterProvider router={platformRouter} />
      </Suspense>
    </QueryClientProvider>
  </ConfigProvider>
);
